import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import 'moment/locale/es';
import 'moment/locale/fr';
import 'moment/locale/en-gb';
import { capitalizeFirstLetter, DATE_TIME_FORMAT_NAME_MODEL, setMomentLanguage } from '../../../Apis/functions';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */

/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const LiveClockAndDateApp = () => {
    const { i18n } = useTranslation();

    // State to store current time
    const [hour, setHour] = useState(moment());

    /**
     * Update moment locale when application language changes
     */
    useEffect(() => {
    setMomentLanguage(i18n.language);
}, [i18n.language]);

    /**
     * Update current time every second
     */
    useEffect(() => {
        const interval = setInterval(() => {
            setHour(moment());
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    /**
     * Formatted current hour
     * Example: 14:35
     */
    const hourFormat = hour.format(DATE_TIME_FORMAT_NAME_MODEL.HHmm);

    return {
        hourFormat,
    };
};

export default LiveClockAndDateApp;
